document.addEventListener('DOMContentLoaded', function () {
    // Modal functionality: Listen for the modal toggle button click.
    document.querySelectorAll('[data-quiz-modal="toggle"]').forEach(function (modalBtn) {
        modalBtn.addEventListener('click', function () {
        const quizContainer = document.querySelector('.size-quiz-container.popup');
        if (quizContainer) {
            // Add the active class to display the quiz as a popup/modal.
            quizContainer.classList.add('active');
            // Optionally disable body scrolling while the modal is open.
            document.body.style.overflow = 'hidden';
        }
        });
    });

    // Modal close functionality: Listen for the close button click.
    const modalClose = document.querySelector('.quiz-modal-close');
    if (modalClose) {
        modalClose.addEventListener('click', function () {
        const quizContainer = document.querySelector('.size-quiz-container.popup');
        if (quizContainer) {
            quizContainer.classList.remove('active');
            // Re-enable background scrolling when the modal is closed.
            document.body.style.overflow = '';
        }
        });
    }

    // Get all quiz slides (each has the class .quiz-slide--container)
    const slides = document.querySelectorAll('.quiz-slide--container');
    // Variable to keep track of the active slide index (starting at 0)
    let activeSlide = 0;
    // Object to hold answer selections, keyed by slide index.
    const answers = {};
    // Variable to store the timer ID for the calculating slide transition.
    let calculationTimer = null;
  
    // Initially, only the first slide is shown; hide all others.
    slides.forEach((slide, index) => {
      slide.style.display = index === activeSlide ? 'flex' : 'none';
    });
  
    // Save the original base text from the results-text element (from the Liquid results_text setting)
    const resultsContainer = document.querySelector('.results--container');
    const resultsTextElement = resultsContainer.querySelector('.results-text');
    const baseResultsText = resultsTextElement.textContent.trim();
  
    // Function to transition to a given slide index.
    function goToSlide(index) {
      // Ensure the new index is within the valid range.
      if (index < 0 || index >= slides.length) return;
      
      // If leaving the calculating slide (index 2), clear any active timer.
      if (activeSlide === 2 && calculationTimer !== null) {
        clearTimeout(calculationTimer);
        calculationTimer = null;
      }
      
      // Hide the current slide.
      slides[activeSlide].style.display = 'none';
      
      // Update the active slide index.
      activeSlide = index;
      
      // Show the new active slide.
      slides[activeSlide].style.display = 'flex';
    }
  
    // Helper function to determine the final size label.
    // It first applies the primary matching criteria.
    // If no primary match, it then checks the fallback criteria.
    // If neither returns a valid size label, returns an empty string.
    function getSizeLabel(preBaby, bust) {
      // --- Primary Logic ---
      if (preBaby === "Size 0/2" && bust === '30-35"') {
        return "XXS!";
      } else if (preBaby === "Size 2/4" && (bust === '30-35"' || bust === '35.5-37"')) {
        return "XS!";
      } else if ((preBaby === "Size 4/6" || preBaby === "Size 6/8") &&
                 (bust === '30-35"' || bust === '35.5-37"' || bust === '37.5-39"')) {
        return "S!";
      } else if ((preBaby === "Size 8/10" || preBaby === "Size 10/12") &&
                 (bust === '30-35"' || bust === '35.5-37"' || bust === '37.5-39"' || bust === '39.5-41"')) {
        return "M!";
      } else if ((preBaby === "Size 12/14" || preBaby === "Size 14/16") &&
                 (bust === '30-35"' || bust === '35.5-37"' || bust === '37.5-39"' || bust === '39.5-41"' || bust === '41.5-44"')) {
        return "L!";
      } else if (preBaby === "Size 16/18" &&
                 (bust === '30-35"' || bust === '35.5-37"' || bust === '37.5-39"' || bust === '39.5-41"' || bust === '41.5-44"' || bust === '44.5-47"')) {
        return "XL!";
      } else if (preBaby === "Size 18/20" &&
                 (bust === '30-35"' || bust === '35.5-37"' || bust === '37.5-39"' || bust === '39.5-41"' || bust === '41.5-44"' || bust === '44.5-47"' || bust === '47.5-50"')) {
        return "1X PLUS!";
      } else if ((preBaby === "Size 20/22" || preBaby === "Size 22/24") &&
                 (bust === '30-35"' || bust === '35.5-37"' || bust === '37.5-39"' || bust === '39.5-41"' || bust === '41.5-44"' || bust === '44.5-47"' || bust === '47.5-50"' || bust === '50.5-53"')) {
        return "2X PLUS!";
      } else if (preBaby === "Size 24/26" &&
                 (bust === '30-35"' || bust === '35.5-37"' || bust === '37.5-39"' || bust === '39.5-41"' || bust === '41.5-44"' || bust === '44.5-47"' || bust === '47.5-50"' || bust === '50.5-53"' || bust === '53.5-57"' || bust === 'over 57"')) {
        return "3X PLUS!";
      }
      // --- Fallback Logic ---
      // XS fallback: preBaby "Size 0/2" or "Size 2/4" and bust is "35.5-37"
      if ((preBaby === "Size 0/2" || preBaby === "Size 2/4") && bust === '35.5-37"') {
        return "XS!";
      } 
      // S fallback: preBaby "Size 0/2", "Size 2/4", or "Size 4/6" and bust is "37.5-39"
      if ((preBaby === "Size 0/2" || preBaby === "Size 2/4" || preBaby === "Size 4/6") && bust === '37.5-39"') {
        return "S!";
      } 
      // M fallback: preBaby "Size 0/2", "Size 2/4", "Size 4/6", "Size 6/8", "Size 8/10", or "Size 10/12" and bust is "39.5-41"
      if ((preBaby === "Size 0/2" || preBaby === "Size 2/4" || preBaby === "Size 4/6" || preBaby === "Size 6/8" || preBaby === "Size 8/10" || preBaby === "Size 10/12") && bust === '39.5-41"') {
        return "M!";
      }
      // L fallback: preBaby "Size 0/2", "Size 2/4", "Size 4/6", "Size 6/8", "Size 8/10", "Size 10/12", or "Size 12/14" and bust is "41.5-44"
      if ((preBaby === "Size 0/2" || preBaby === "Size 2/4" || preBaby === "Size 4/6" || preBaby === "Size 6/8" || preBaby === "Size 8/10" || preBaby === "Size 10/12" || preBaby === "Size 12/14") && bust === '41.5-44"') {
        return "L!";
      }
      // XL fallback: preBaby "Size 4/6", "Size 6/8", "Size 8/10", "Size 10/12", "Size 12/14", or "Size 16/18" and bust is "44.5-47"
      if ((preBaby === "Size 4/6" || preBaby === "Size 6/8" || preBaby === "Size 8/10" || preBaby === "Size 10/12" || preBaby === "Size 12/14" || preBaby === "Size 16/18") && bust === '44.5-47"') {
        return "XL!";
      }
      // 1X fallback: preBaby "Size 8/10", "Size 10/12", "Size 12/14", "Size 14/16", "Size 16/18", or "Size 18/20" and bust is "47.5-50"
      if ((preBaby === "Size 8/10" || preBaby === "Size 10/12" || preBaby === "Size 12/14" || preBaby === "Size 14/16" || preBaby === "Size 16/18" || preBaby === "Size 18/20") && bust === '47.5-50"') {
        return "1X PLUS!";
      }
      // 2X fallback: preBaby "Size 8/10", "Size 10/12", "Size 12/14", "Size 14/16", "Size 16/18", "Size 18/20", or "Size 20/22" and bust is "50.5-53"
      if ((preBaby === "Size 8/10" || preBaby === "Size 10/12" || preBaby === "Size 12/14" ||
           preBaby === "Size 14/16" || preBaby === "Size 16/18" || preBaby === "Size 18/20" || preBaby === "Size 20/22") && bust === '50.5-53"') {
        return "2X PLUS!";
      }
      // 3X fallback: preBaby "Size 8/10", "Size 10/12", "Size 12/14", "Size 14/16", "Size 16/18", "Size 18/20", or "Size 20/22"
      // and bust is "53.5-57" or "over 57"
      if ((preBaby === "Size 8/10" || preBaby === "Size 10/12" || preBaby === "Size 12/14" ||
           preBaby === "Size 14/16" || preBaby === "Size 16/18" || preBaby === "Size 18/20" || preBaby === "Size 20/22") &&
          (bust === '53.5-57"' || bust === 'over 57"')) {
        return "3X PLUS!";
      }
      
      // If no condition is met, return an empty string.
      return "";
    }
  
    // Function to calculate and display results based on the answers selected.
    function calculateResults() {
      const preBaby = answers[0] || 'No Answer for Question 1';
      const bust = answers[1] || 'No Answer for Question 2';
      // Compute the final size label based on the selected answers.
      const sizeLabel = getSizeLabel(preBaby, bust);
      
      // If a valid size label was computed, append it to the base results text.
      if (sizeLabel !== "") {
        resultsTextElement.textContent = baseResultsText + " " + sizeLabel;
      } else {
        // If no matching result, only display the email text.
        resultsTextElement.textContent = "";
      }
    }
  
    // Event listener for answer clicks.
    const answerItems = document.querySelectorAll('.answer');
    answerItems.forEach(item => {
      item.addEventListener('click', function () {
        // Find the parent slide of this answer.
        const currentSlideContainer = this.closest('.quiz-slide--container');
        const currentSlideIndex = Array.from(slides).indexOf(currentSlideContainer);
        
        // Record the selected answer's value (from the data-value attribute).
        answers[currentSlideIndex] = this.getAttribute('data-value');
        
        // Transition to the next slide.
        goToSlide(currentSlideIndex + 1);
        
        // If the answer came from the second question slide (index 1)
        // then calculate the results and set a timer to auto-advance.
        if (currentSlideIndex === 1) {
          calculateResults();
          // Set a 3-second timer before transitioning from the calculating slide (index 2)
          // to the results slide (index 3).
          calculationTimer = setTimeout(() => {
            // Ensure the user is still on the calculating slide before transitioning.
            if (activeSlide === 2) {
              goToSlide(3);
            }
          }, 3000);
        }
      });
    });
  
    // Event listener for back button clicks.
    const backButtons = document.querySelectorAll('.quiz-back-button');
    backButtons.forEach(button => {
      button.addEventListener('click', function () {
        // Find the current slide index.
        const currentSlideContainer = this.closest('.quiz-slide--container');
        const currentSlideIndex = Array.from(slides).indexOf(currentSlideContainer);
        
        // If on the calculating slide, clear the timer.
        if (activeSlide === 2 && calculationTimer !== null) {
          clearTimeout(calculationTimer);
          calculationTimer = null;
        }
        
        // Navigate to the previous slide.
        goToSlide(currentSlideIndex - 1);
      });
    });
});  